const colors = {
  background: {
    default: "#f8f9fa",
  },

  text: {
    main: "#2d3748", // Modern dark slate for better readability
    focus: "#1a202c",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#f9fafb",
  },

  black: {
    light: "#2d3748",
    main: "#1a202c",
    focus: "#0d1219",
  },

  primary: {
    main: "#8b0000", // Slightly modernized dark red
    focus: "#700000",
  },

  secondary: {
    main: "#4a5568", // Modern slate gray for secondary actions
    focus: "#2d3748",
  },

  info: {
    main: "#8b0000", // Keeping the red theme for info
    focus: "#700000",
  },

  success: {
    main: "#38a169", // Modern green for success states
    focus: "#2f855a",
  },

  warning: {
    main: "#d69e2e", // Modern amber for warnings
    focus: "#b7791f",
  },

  error: {
    main: "#e53e3e", // Modern red for errors
    focus: "#c53030",
  },

  light: {
    main: "#f7fafc",
    focus: "#edf2f7",
  },

  dark: {
    main: "#1a202c", // Modern dark slate
    focus: "#0d1219",
  },

  grey: {
    100: "#f7fafc",
    200: "#edf2f7",
    300: "#e2e8f0",
    400: "#cbd5e0",
    500: "#a0aec0",
    600: "#718096",
    700: "#4a5568",
    800: "#2d3748",
    900: "#1a202c",
  },

  gradients: {
    primary: {
      main: "#700000", // Dark red
      state: "#8b0000", // Red
    },

    secondary: {
      main: "#2d3748", // Dark slate
      state: "#4a5568", // Medium slate
    },

    info: {
      main: "#700000", // Dark red to match primary brand color
      state: "#8b0000",
    },

    success: {
      main: "#2f855a", // Deeper green
      state: "#38a169", // Brighter green
    },

    warning: {
      main: "#b7791f", // Deeper amber
      state: "#d69e2e", // Brighter amber
    },

    error: {
      main: "#c53030", // Deeper red
      state: "#e53e3e", // Brighter red
    },

    light: {
      main: "#e2e8f0",
      state: "#f7fafc",
    },

    dark: {
      main: "#0d1219", // Very dark slate
      state: "#1a202c", // Dark slate
    },
  },

  socialMediaColors: {
    // Social Media Colors bleiben unverändert
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  alertColors: {
    primary: {
      main: "#8b0000", // Dark red
      state: "#700000",
      border: "#fed7d7", // Light red/pink
    },

    secondary: {
      main: "#4a5568", // Slate
      state: "#2d3748",
      border: "#e2e8f0", // Light slate
    },

    info: {
      main: "#8b0000", // Matching primary
      state: "#700000",
      border: "#fed7d7", // Light red/pink
    },

    success: {
      main: "#38a169", // Green
      state: "#2f855a",
      border: "#c6f6d5", // Light green
    },

    warning: {
      main: "#d69e2e", // Amber
      state: "#b7791f",
      border: "#feebc8", // Light amber
    },

    error: {
      main: "#e53e3e", // Red
      state: "#c53030",
      border: "#fed7d7", // Light red
    },

    light: {
      main: "#e2e8f0",
      state: "#edf2f7",
      border: "#f7fafc",
    },

    dark: {
      main: "#1a202c", // Dark slate
      state: "#0d1219",
      border: "#a0aec0", // Medium slate
    },
  },

  badgeColors: {
    primary: {
      background: "#fed7d7", // Light red/pink
      text: "#8b0000", // Dark red
    },

    secondary: {
      background: "#e2e8f0", // Light slate
      text: "#4a5568", // Medium slate
    },

    info: {
      background: "#fed7d7", // Light red/pink to match primary
      text: "#8b0000", // Dark red
    },

    success: {
      background: "#c6f6d5", // Light green
      text: "#38a169", // Green
    },

    warning: {
      background: "#feebc8", // Light amber
      text: "#d69e2e", // Amber
    },

    error: {
      background: "#fed7d7", // Light red
      text: "#e53e3e", // Red
    },

    light: {
      background: "#ffffff",
      text: "#718096", // Medium slate
    },

    dark: {
      background: "#2d3748", // Dark slate
      text: "#ffffff",
    },
  },

  inputColors: {
    borderColor: { main: "#cbd5e0", focus: "#8b0000" }, // Focus color matches primary
    boxShadow: "#fed7d7", // Light red/pink
    error: "#e53e3e", // Red
    success: "#38a169", // Green
  },

  sliderColors: {
    thumb: { borderColor: "#8b0000" }, // Matches primary
  },

  circleSliderColors: {
    background: "#fed7d7", // Light red/pink
  },

  tabs: {
    indicator: { boxShadow: "#8b0000" }, // Matches primary
  },
};

export default colors;
